<form [formGroup]="mainForm">
  <nb-card>
    <nb-card-header>
      <div class="title">
        {{ title }}
      </div>
    </nb-card-header>

    <nb-card-body>
      <p [innerHtml]="body">
        <!-- {{ body }} -->
      </p>
    </nb-card-body>

    <nb-card-footer>
      <div class="row justify-content-between data-row">
        <div>
          <button nbButton status="primary" class="button-save" (click)="save()">
            {{textOk}}
          </button>
        </div>

        <div>
          <button nbButton status="info" class="button-cancel" (click)="cancel()">
            {{textNo}}
          </button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</form>
